module.exports = __webpack_public_path__ + "static/media/sdg_icon_9.210be1d5.png";